<template>
  <!-- 搜索结果 -->
  <div class="p-absolute top-51 left-0 bottom-0 w-100-p bg-white" id="search-value-box" style="padding-top: 39px;">
    <div class="p-absolute top-0 left-0 w-100-p h-39 b-b b-c-g-100">
      <ul class="d-table w-100-p h-100-p">
        <li class="p-relative d-table-cell h-100-p t-a-center v-a-middle cursor-pointer cursor-pointer user-select-none c-blue-hover search-tab-element" @mousedown.prevent="changeTabState" :style="{width:100/tabs.length+'%'}" v-for="item in tabs" :key="item.value" :class="{'c-blue':navSelctType===item.value}">
          <label>{{item.name}}<input class="d-none" type="radio" :value="item.value" name="imNavTabRadio" v-model="navSelctType"></label>
          <i class="d-none p-absolute left-0 right-0 m-auto h-2" :class="{'d-block':navSelctType===item.value}" style="bottom: -1px; background-color: #653EB3;" :style="{width:item.labelWidth}"></i>
        </li>
      </ul>
    </div>
    <!-- 全部 -->
    <div class="h-100-p o-auto left-personnel-box" v-show="navSelctType==='0'">
      <!--只能用v-show，否则onBodyClickHandlerNew判断条件出错-->
      <im-search-history v-show="!keyWord" @clearSearchHistoryState="clearSearchHistoryState" @searchNearestHistory="searchNearestHistory"/>
      <template v-if="keyWord">
        <im-history-record :width="width" :im="im" :hasMore="hasMore" :historyRecord="historyRecord" @dragHistoryBox="dragHistoryBox" :keyWord="keyWord" :navSelctType="navSelctType" @closeHistoryRecord="closeHistoryRecord" @enterChatRoom="enterChatRoom" @switchTab="switchTab" v-if="keyWord"/>
        <im-search-kcode :width="width" :im="im" :keyWord="keyWord" :kcodeItems="searchKcodeList" :currentnavSelctType="'1'" :navSelctType="navSelctType"  @returnToKcode="returnToKcode" @switchTab="switchTab" @createSession="createSession" v-if="keyWord&&searchKcodeList.length"/>
        <im-search-member :width="width" :im="im" :keyWord="keyWord" :searchedNumber="searchedNumber" :currentnavSelctType="'2'" :navSelctType="navSelctType" @switchTab="switchTab" @createSession="createSession" v-if="keyWord&&searchedNumber.length"/>
        <im-search-team :width="width" :im="im" :keyWord="keyWord" :searchTeamList="searchTeamList" :searchedDataTeam="searchedDataTeam" :currentnavSelctType="'3'" :navSelctType="navSelctType" @switchTab="switchTab" @createSession="createSession" v-if="keyWord&&(searchTeamList.length||searchedDataTeam.teamId)"/>
       <!-- <div class="h-36 l-h-36 p-l-16 p-r-12 flex justify-content-between align-items-center cursor-pointer" @click="searchNetTeam" style="color: #653EB3;border-bottom: 1px solid #f2f2f2;"><span class="d-block">网络查找公开群聊</span><img src="@/assets/images/im/arrow-right@2x.png" class="d-block" style="width: 8px;height:14px"/></div>-->
        <div class="t-a-center p-x-20 l-h-24 p-y-10" v-if="!searchKcodeList.length&&keyWord&&!searchedNumber.length&&!searchTeamList.length&&!historyRecord.length&&!searchedDataTeam.teamId">未搜索到 “{{keyWord}}” 的相关内容</div>
      </template>
    </div>
    <!-- 网点 -->
    <div class="h-100-p o-auto left-personnel-box" v-show="navSelctType==='1'">
      <im-search-kcode :width="width" :kcodeKey="kcodeKey" :im="im" :keyWord="keyWord" :kcodeItems="searchKcodeList" :currentnavSelctType="navSelctType" @createSession="createSession" :navSelctType="navSelctType"/>
    </div>
    <!-- 我的组织 -->
    <div class="h-100-p o-auto left-personnel-box" v-show="navSelctType==='2'">
      <im-search-member :width="width" :im="im" :keyWord="keyWord" :searchedNumber="searchedNumber" :currentnavSelctType="navSelctType" @createSession="createSession" :navSelctType="navSelctType"/>
    </div>
    <!-- 群聊 -->
    <div class="h-100-p o-auto left-personnel-box" v-show="navSelctType==='3'">
      <im-search-team :width="width" :im="im" :keyWord="keyWord" :searchTeamList="searchTeamList" :searchedDataTeam="searchedDataTeam" :currentnavSelctType="navSelctType" @createSession="createSession" :navSelctType="navSelctType"/>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    im: {
      type: Object,
      default: function () {
        return {}
      }
    },
    id: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 250
    },
    sceneCp:{
      type: String,
      default: ''
    },
    keyWord:{
      type: String,
      default: ''
    },
    hasMore:{
      type: Boolean,
      default: false
    },
    closeSearchBoxFlag:{
      type: Boolean,
      default: false
    },
    searchKcodeList:{//我的组织成员
      type: Array,
      default: function(){
        return []
      }
    },
    searchedNumber: {//群组成员
      type: Array,
      default: function () {
        return [];
      }
    },
    searchTeamList: {//群组成员
      type: Array,
      default: function () {
        return [];
      }
    },
    historyRecord: {//群组成员
      type: Array,
      default: function () {
        return [];
      }
    },
  },
  data: function () {
    return {
      tabs: [
        { value: '0', name: '全部', labelWidth: '44px' },
        { value: '1', name: '网点', labelWidth: '45px' },
        { value: '2', name: '我的组织', labelWidth: '44px' },
        { value: '3', name: '群聊', labelWidth: '45px' },
        // { value: '1', name: '联系人', labelWidth: '45px' },
        // { value: '2', name: '聊天记录', labelWidth: '44px' },
        
      ],
      // 选择tab类型,0 全部、1 联系人、2 聊天记录
      navSelctType: '0',
      currentnavSelctType:'',
      showHistoryReacdFlag: false,//显示历史记录
      // showSearchResultFlag: false,//显示搜索结果
      // searchedNumber: [],//搜索到的联系人
      // historyRecord: [],//搜索的聊天记录
      // searchTeamList:[],
      // searchKcodeList:[],
      contactLoading: false,
      kcodeItems: [],
      kecodeflag: false,
      kcodeKey:{},
      searchedDataTeam:{},
    };
  },
  components: {
    //搜素记录
    'im-search-history': () => import('./im-search-history.vue'),
    //联系人
    'im-search-member': () => import('./im-search-member.vue'),
    //联系人
    'im-search-kcode': () => import('./im-search-kcode.vue'),
    //联系人
    'im-search-team': () => import('./im-search-team.vue'),
    // 聊天记录
    'im-history-record': () => import('./im-history-record.vue')
  }, 
  created: function () {
    // this.getCustomerInfo();
    // 点击添加群组时弹出框不显示群组tab
    // this.noSHowGroup();
    // var grounId = newUserinfo?JSON.parse(newUserinfo):{};
    // var currentGrounId = grounId.groupId?grounId.groupId:'';
    // this.groupId = currentGrounId;
  },
  mounted:function () {

  },
  computed: {
    
  },
  methods: {
    //搜索网络群聊
    searchNetworkTeam(){
      let $this = this;
      this.im.getTeam({
          teamId: $this.keyWord,
          done: function (err, obj) {
            if(!err){
              if(obj.hasOwnProperty('serverCustom') && obj.serverCustom && JSON.parse(obj.serverCustom) && JSON.parse(obj.serverCustom).groupType && JSON.parse(obj.serverCustom).groupType == 'yj'){
                return;
              }
              for(const [key,value] of Object.entries(obj)){
                $this.$set($this.searchedDataTeam,key,value)
              }
              $this.$set($this.searchedDataTeam,'isNetWorkSearch',true);
            }
          }
      });
    },
    searchNetTeam(){
      this.navSelctType = "3";
    },
    clearSearchHistoryState(){
      this.$emit("clearSearchHistoryState",true);
    },
    changeTabState(){
      this.$emit('changeTabState',true);
    },
    dragHistoryBox(data){
      this.$emit("dragHistoryBoxTo",data);
      console.log('dragHistoryBox',data);
    },
    returnToKcode: function(data){
      this.navSelctType = data.currentnavSelctType;
      this.kcodeKey = data.item;
    },
    enterChatRoom:function(user){
      this.$emit("enterChatRoom",user);
      this.closeHistoryRecord();
    },
    createSession:function(item){
      this.$emit("createSession",item);
      this.closeHistoryRecord();
    },
    closeHistoryRecord:function(){
      this.navSelctType = "0";
      this.$emit("closeSearchDialog")
    },
    switchTab:function(val){
      if(val == 1){
        this.$emit("searchtabNavchange",'1');
      }else if(val == 2){
        this.$emit("searchtabNavchange",'2');
      }else if(val == 3){
        this.$emit("searchtabNavchange",'3');
      }else{
        this.$emit("searchtabNavchange",'0');
      }
      this.navSelctType = val;
    },
    searchNearestHistory:function(item){
      this.$emit("searchNearestHistory",item)
    },
  },
  watch: {
    navSelctType:function(){
      this.$emit("searchtabNavchange",'0')
    },
    keyWord: function (val) {
      if(val){
        this.searchNetworkTeam()
      }else{

      }
      console.log('val--------------',val)
    },
    closeSearchBoxFlag: function(val){
      if(val){
        this.closeHistoryRecord();
      }else{
        this.searchedDataTeam = {};
      }
    },
  },
  beforeDestroy:function(){
    this.closeHistoryRecord();
  }
}
</script>
